import { useAuth } from "@/context/AuthContext";
import EmployeeHome from "@/pages/home/EmployeeHome";
import SupervisorHome from "@/pages/home/SupervisorHome";
import AdminHome from "@/pages/home/AdminHome";
import SuperHome from "@/pages/home/SuperHome";

// Role-aware home hub: each role lands on a screen built for them.
export default function Dashboard() {
  const { role, isSuperAdmin } = useAuth();
  if (isSuperAdmin) return <SuperHome />;
  if (role === "org_admin") return <AdminHome />;
  if (role === "supervisor") return <SupervisorHome />;
  return <EmployeeHome />;
}
